/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum PassSessionType {
  PRIVATE = 'private',
  EVENT = 'event',
}
